<template>
    <div class="button-container">
        <ion-button size="large" shape="round" style="font-weight: bold; --box-shadow: 0px 5px 5px gray" router-link="/menu"> START YOUR ORDER </ion-button>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IonButton } from '@ionic/vue';

export default defineComponent({
    components: { IonButton },
});
</script>

<style scoped>
.button-container {
    display: flex;
    justify-content: center;
    margin: 10px;
}
</style>
